import request from '@/utils/request'

// 查询用户评论列表
export function listComment(query) {
  return request({
    url: '/user/comment/list',
    method: 'get',
    params: query
  })
}

// 查询用户评论分页
export function pageComment(query) {
  return request({
    url: '/user/comment/page',
    method: 'get',
    params: query
  })
}

// 查询用户评论详细
export function getComment(data) {
  return request({
    url: '/user/comment/detail',
    method: 'get',
    params: data
  })
}

// 新增用户评论
export function addComment(data) {
  return request({
    url: '/user/comment/add',
    method: 'post',
    data: data
  })
}

// 修改用户评论
export function updateComment(data) {
  return request({
    url: '/user/comment/edit',
    method: 'post',
    data: data
  })
}

// 删除用户评论
export function delComment(data) {
  return request({
    url: '/user/comment/delete',
    method: 'post',
    data: data
  })
}
